import Clarity from '@microsoft/clarity';

export function initClarity(projectId: string): void {
  if (!projectId || typeof projectId !== 'string' || projectId.trim() === '') {
    return;
  }
  try {
    Clarity.init(projectId.trim());
  } catch (error) {
    console.error('Error initializing Microsoft Clarity:', error);
  }
}
